module.exports = __webpack_public_path__ + "img/logo-hes-so.d19c1aa9.svg";